function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "4xc9n696gb",
  d: "M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 13.6c-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8.442 0 .8.358.8.8 0 .442-.358.8-.8.8zm1.736-5.464c-.4.408-.688.776-.832 1.352-.012.046-.022.102-.033.168-.068.428-.437.744-.871.744h-.144c-.362 0-.656-.294-.656-.656 0-.368.064-.464.176-.792.16-.464.424-.88.76-1.216l.992-1.008c.368-.352.544-.88.44-1.44-.104-.576-.552-1.064-1.112-1.224-.888-.248-1.712.256-1.976 1.016-.096.296-.344.52-.656.52h-.24c-.464 0-.784-.448-.656-.896.344-1.176 1.344-2.072 2.584-2.264 1.216-.192 2.376.44 3.096 1.44.944 1.304.664 2.704-.152 3.52l-.72.736z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1222 -444) translate(1222 444)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#4xc9n696gb"
}))))));

var SvgQuestionIcon = function SvgQuestionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/questionIcon.d4d66892.svg";
export { ForwardRef as ReactComponent };